import React, { useEffect, useState } from "react";
import { mergeParams } from "../../helpers/helpers";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";

export default function Lista({ location, history }) {
  const [carregando, setCarregando] = useState(false);
  const [lista, setLista] = useState([]);

  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        nome: "",
        exibirInativos: false,
      },
      location
    )
  );

  useEffect(() => {
    carregar();
  }, []);

  const carregar = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    setCarregando(true);
    api.get("planosAulas/listar", filtrosEnviar).then((res) => {
      setLista(res);
      setCarregando(false);
    });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 10,
        value: filtros.nome,
      },
      exibirInativos: {
        type: "check",
        label: "Exibir inativas",
        space: 2,
        value: filtros.ativas,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Planos de aulas",
    key: "id",
    onLineClick: (id) => history.push(`/app/planos-aulas/${id}`),
    newItemAction: () => history.push("/app/planos-aulas/0"),
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
